// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  decisionId: __t.u64(),
  newTitle: __t.string(),
  newBodyMd: __t.string(),
  newEvidenceRefsJson: __t.string(),
  authorAgentId: __t.option(__t.u64()),
  authorKind: __t.string(),
};
